const WIDTH_SP = 768;

(() => {

  // 初期化処理
  const init = () => {
    const body = document.querySelector('body');
    body.classList.remove('preload');

    // 各初期化関数の呼び出し
    initHeader();
    initRetina();
    initImage();
    initSmoothScroll();
    initIsOn();
    initMenu();
    doFade();
    initTextStroke();
  };

  // リサイズイベント処理
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initTextStroke();
    }, 200);
  };

  // スクロールイベント処理
  let lastScrollTime = 0;
  const handleScroll = () => {
    const now = Date.now();
    if (now - lastScrollTime >= 100) {
      doFade();
      initIsOn();
      lastScrollTime = now;
    }
  };

  // イベントリスナーの登録
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', handleResize);
  document.addEventListener('scroll', handleScroll);
  
})();

// ヘッダーの固定処理
const initHeader = () => {
  const header = document.getElementById('header');
  const target = document.querySelector('.js-menu-disp');
  // const nextElem = header.nextElementSibling;
  // const headerH = header.clientHeight;

  if (!header || !target) return;

  let wasFixed = false; // flag

  window.addEventListener('scroll', () => {
    const targetTop = target.getBoundingClientRect().top;

    if (targetTop < 0 && !wasFixed) {
      // fixedクラスを追加
      header.classList.add('fixed');
      header.classList.remove('sliding-up');
      //nextElem.style.marginTop = headerH + "px";
      wasFixed = true;
    } else if (targetTop >= 0 && wasFixed) {
      // fixedクラスを削除し、sliding-upクラスを一時的に追加
      header.classList.add('sliding-up');
      wasFixed = false;

      // アニメーション終了後に sliding-up クラスを削除
      setTimeout(() => {
        header.classList.remove('sliding-up');
        header.classList.remove('fixed');
        //nextElem.style.marginTop = "";
      }, 500);
    }
  });
};

// Retina対応
const initRetina = () => {
  if (window.devicePixelRatio >= 2) {
    document.querySelectorAll('.retina').forEach(img => {
      const retinaSrc = img.getAttribute('src').replace(/\.(?=(?:png|jpg|jpeg)$)/i, '@2x.');
      img.setAttribute('srcset', `${retinaSrc} 2x`);
    });
  }
};

// WebP対応
const initImage = () => {
  const isSupportsWebP = callback => {
    const webP = new Image();
    webP.onload = webP.onerror = () => callback(webP.height === 2);
    webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
  };

  isSupportsWebP(isSupported => {
    if (isSupported) {
      document.querySelectorAll('img.webp').forEach(img => {
        const dataSrc = img.getAttribute('data-src');
        if (dataSrc) {
          const webpSrc = dataSrc.replace(/\.(jpg|jpeg|png)$/i, '.webp');
          img.setAttribute('data-src', webpSrc);
          img.setAttribute('src', webpSrc);
        }

        const parentPicture = img.closest('picture');
        if (parentPicture) {
          const source = parentPicture.querySelector('source');
          if (source?.getAttribute('data-srcset')) {
            const webpSrcSet = source.getAttribute('data-srcset').replace(/\.(jpg|jpeg|png)$/i, '.webp');
            source.setAttribute('data-srcset', webpSrcSet);
            source.setAttribute('srcset', webpSrcSet);
          }
        }
      });

      document.querySelectorAll('video.webp[poster]').forEach(video => {
        const poster = video.getAttribute('poster');
        if (poster) {
          const webpPoster = poster.replace(/\.(jpg|jpeg|png)$/i, '.webp');
          video.setAttribute('poster', webpPoster);
        }
      });
    }
  });
};

// メニュー初期化
const initMenu = () => {
  const iconMenu = document.getElementById('icon-menu');
  const headerMenu = document.getElementById('header-menu');

  iconMenu?.addEventListener('click', () => {
    iconMenu.classList.toggle('checked');
    headerMenu.classList.toggle('active');
  });

  document.querySelectorAll('.header__nav-item a').forEach(link => {
    link.addEventListener('click', () => {
      iconMenu.classList.remove('checked');
      headerMenu.classList.remove('active');
    });
  });
};

// スムーススクロール
const initSmoothScroll = () => {
  document.querySelectorAll('a[href^="#"]').forEach(trigger => {
    trigger.addEventListener('click', e => {
      e.preventDefault();
      const targetId = trigger.getAttribute('href').replace('#', '');
      const targetElement = document.getElementById(targetId);
      if (targetElement) adjustScrollPosition(targetElement, 'smooth');
    });
  });
};

const adjustScrollPosition = (targetElement, behavior = 'smooth') => {
  const rect = targetElement.getBoundingClientRect().top;
  const offset = window.pageYOffset;
  const gap = document.getElementById('header')?.clientHeight || 0 + 80;
  const target = rect + offset - gap;

  window.scrollTo({ top: target, behavior });
};

// スクロールでis-onクラスを付与
const initIsOn = () => {
  document.querySelectorAll('.js-scroll').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;

    const isLoad = elem.dataset.load !== undefined;
    const dispPosition = offset - windowHeight;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('is-on');
    }
  });
};

// 要素のフェード
const doFade = () => {
  document.querySelectorAll('.js-fade-in').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;
    const delay = parseFloat(elem.dataset.delay) || 0;
    const isLoad = elem.dataset.load !== undefined;
    const positionPc = parseFloat(elem.dataset.positionPc) || 200;
    const positionSp = parseFloat(elem.dataset.positionSp) || 0;
    const position = document.body.clientWidth > WIDTH_SP ? positionPc : positionSp;
    const dispPosition = offset - windowHeight + position;
    const duration = parseFloat(elem.dataset.duration) || 1.5;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('js-scroll-in');
      elem.style.transitionDelay = `${delay}s`;
      elem.style.transitionDuration = `${duration}s`;
    }
  });
};

// 縁取り文字
const initTextStroke = () => {
  const svgs = document.querySelectorAll(".text-stroke");

  svgs.forEach(svgContainer => {
    const allTextElements = svgContainer.querySelectorAll(".text-stroke__text");

    // すべてのテキスト要素に対する処理
    allTextElements.forEach(textElement => {
      const safeGetBBox = (element, callback) => {
        let attempts = 0;
        const maxAttempts = 10; // 最大10回まで再試行

        const attemptBBox = () => {
          try {
            const bbox = element.getBBox();
            callback(bbox);
          } catch (e) {
            if (++attempts <= maxAttempts) {
              console.warn(
                `getBBox が失敗しました。再試行中... (${attempts}/${maxAttempts})`,
                element
              );
              requestAnimationFrame(attemptBBox);
            } else {
              console.error(
                "getBBox の再試行が最大回数を超えました:",
                element
              );
            }
          }
        };

        attemptBBox();
      };

      // テキストに応じた viewBox を設定
      const setViewBox = textElement => {
        safeGetBBox(textElement, bbox => {
          const padding = 10; // 十分な余白を設定
          const width = bbox.width + padding * 2;
          const height = bbox.height + padding * 2;
          const x = bbox.x - padding;
          const y = bbox.y - padding;

          svgContainer.setAttribute("viewBox", `${x} ${y} ${width} ${height}`);
          svgContainer.style.width = `${width}px`; // 幅を明示的にピクセルで指定
          svgContainer.style.height = `${height}px`; // 高さも同様
        });
      };

      // viewBox の設定
      setViewBox(textElement);
    });
  });
};